import NoticeService from '@/services/noticeservice'
// init state
const state = {
  notices: [],
  countNoticeUnread: 0
}
// getters
const getters = {
  getNotices: state => state.notices.slice(0, 5),
  getHomeNotices: state => state.notices.slice(0, 10),
  countNoticeUnread: state => state.countNoticeUnread
}
// actions
const actions = {
  fetchNotices (context) {
    NoticeService.getNotices()
      .then(response => {
        context.commit('setNotices', response.recordList.data)
        context.commit('setCountNoticeUnread', response.records.countUnread)
      })
  }
}
// mutations
const mutations = {
  setNoticeStatusRead (state, notice) {
    let updateNotice = state.notices.find(noticeRecord => noticeRecord.id === notice.id)
    if (updateNotice) {
      updateNotice.is_notice_read = true
    }
  },
  setNotices (state, notices) {
    state.notices = notices
  },
  setCountNoticeUnread (state, countNoticeUnread) {
    state.countNoticeUnread = countNoticeUnread
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/notice.js